module.exports = __webpack_public_path__ + "static/img/support.213af35a.png";